// urlCreator allow to save search params when use push from connected-react-router
export const urlCreator = (pathname: string): string => {
  return `${pathname}${window.location.search}`
}
